module.exports = __webpack_public_path__ + "static/media/l-md19.0c349648.png";